import { Component, OnInit, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, FormArray, Validators, UntypedFormBuilder } from '@angular/forms';

import { ApiQName } from '../../api-client-module';
import { ProjectLanguage } from '../../firestore-models/project-language';

import { ConfigurationService } from '../../configuration.service';
import { TranslateService } from '@ngx-translate/core';

export interface MultiQNameDialogData {
  names?: ApiQName[];
}

@Component({
  selector: 'app-multi-qname-dialog',
  templateUrl: './multi-qname-dialog.component.html',
  styleUrls: ['./multi-qname-dialog.component.css'],
  standalone: false,
})
export class MultiQnameDialogComponent implements OnInit {

  //名称×言語数
  names: ApiQName[] = [];
  namesFormGroup!: FormGroup;
  namesArrayControl!: FormArray;
  projectLanguages!: Array<ProjectLanguage>;

  currentLang: string = 'ja';
  projectBaseLang: string = 'ja';

  constructor(
    public dialogRef: MatDialogRef<MultiQnameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MultiQNameDialogData,
    private formBuilder: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.projectLanguages = this.configurationService.getProject().languages!;
    this.names = this.data.names!;
    if (!this.names) {
      this.names = [];
    }
    this.createForm();
    this.namesArrayControl = this.namesFormGroup.get('names') as FormArray;
    this.currentLang = this.translate.currentLang;
    this.projectBaseLang = this.configurationService.getProject().project_base_lang!;
    //プロジェクト基本言語が管理画面の言語と異なる場合、編集不可にする
    if ((this.currentLang == 'en' && this.projectBaseLang == 'ja') || (this.currentLang == 'ja' && this.projectBaseLang != 'ja')) {
      this.namesFormGroup.disable();
    }
  }

  //名称フォーム×言語数
  private createForm() {
    let arrayControl = this.formBuilder.array([]);
    let index: number = 0;
    let isAutoAllTrans: boolean = this.names.length > 0 ? true : false;
    for (const projectLanguage of this.projectLanguages) {
      let auto_trans = false;
      let name = '';
      let trans_name = '';
      for (const value of this.names) {
        if (projectLanguage.lang_code === value.lang_code) {
          if (!value.auto_trans && index !== 0) {
            isAutoAllTrans = false;
          }
          auto_trans = value.auto_trans ? value.auto_trans : false;
          name = value.name;
          trans_name = value.trans_name;
          break
        }
      }
      let _dict = {};
      if (index === 0) {
        _dict = {
          autoTrans: [auto_trans],
          name: [name, [Validators.required]],
          transName: [trans_name],
        }
      } else {
        _dict = {
          autoTrans: [auto_trans],
          name: [name],
          transName: [],
        }
      }
      arrayControl.push(this.formBuilder.group(_dict));
      index++;
    }
    this.namesFormGroup = this.formBuilder.group(
      {
        autoAllTrans: [isAutoAllTrans],
        names: arrayControl
      }
    );
  }

  //更新ボタン
  addNames(): void {
    if (this.namesFormGroup.valid) {
      let names = [];
      for (const index in this.projectLanguages) {
        const ctrl = this.namesArrayControl.controls[index];
        names.push(
          {
            auto_trans: ctrl.get('autoTrans')!.value,
            lang_code: this.projectLanguages[index].lang_code,
            name: ctrl.get('name')!.value,
            trans_name: ctrl.get('transName')!.value,
          }
        )
      }
      this.names = names;
      this.dialogRef.close(this.names);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  //全言語自動翻訳
  onChangeAutoAllTrans(): void {
    const isAutoAllTrans = this.namesFormGroup.get('autoAllTrans')!.value;
    for (const name of this.namesArrayControl.controls) {
      name.get('autoTrans')!.setValue(isAutoAllTrans);
    }
    this.namesArrayControl.controls[0].get('autoTrans')!.setValue(false);
  }

  //言語別自動翻訳
  onChangeAutoTrans(): void {
    let isAutoAllTrans: boolean = true;
    let index = 0;
    for (const name of this.namesArrayControl.controls) {
      if (!name.get('autoTrans')!.value && index !== 0) {
        isAutoAllTrans = false;
        break;
      }
      index++
    }
    this.namesFormGroup.get('autoAllTrans')!.setValue(isAutoAllTrans);
  }

}
